<script>
	import Header from './components/layout/Header.svelte'
	import Features from './components/layout/Features.svelte'
	import Pricing from './components/layout/Pricing.svelte'
	import Signup from './components/layout/SignUp.svelte'
	import Attribution from './components/Attribution.svelte'
</script>

<Header/>
<main>
<Features/>
<Pricing/>
<Signup/>
<Attribution/>
</main>

<style>

</style>